import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Language } from '@types';
import { useTranslation } from 'next-i18next';
import { PATH_PAGE } from '../../routes/paths';
import { generateCDNUrl } from '@/utils/index';

type Props = {
  season: any;
  episode: any;
};

const Episode: React.FC<Props> = ({ season, episode }: Props) => {
  const { locale, query, push } = useRouter();
  const { t } = useTranslation();
  const slug = String(query.series);

  return (
    <>
      <div>
        <div className="flex py-4 space-x-6">
          <div className="relative w-2/5 md:w-2/6 cursor-pointer">
            <Link
              href={PATH_PAGE.episode.view(
                slug,
                season.season_number,
                episode.episode_number,
              )}
            >
              <Image
                src={generateCDNUrl(episode.poster?.name)}
                width="896"
                height="504"
                layout="responsive"
                alt={episode.episode_title}
              />
            </Link>
          </div>
          <div className="w-3/5 md:w-4/6 flex flex-col space-y-3">
            <span className="text-sm md:text-xl font-semibold">
              <Link
                href={PATH_PAGE.episode.view(
                  slug,
                  season.season_number,
                  episode.episode_number,
                )}
              >
                {episode.episode_title}
              </Link>
            </span>
            {/* <span className="font-semibold">T1 - E1 | 1h 16m</span> */}
            <span className="text-sm md:text-base font-semibold">
              {t('s')}
              {season.season_number} - E{episode.episode_number}
            </span>
            <div className="hidden md:block space-y-3">
              <p className="text-sm">
                {locale === Language.EN
                  ? episode.description_200_en || episode.description_en
                  : episode.description_200_es || episode.description_es}
              </p>
              <button
                className="w-24 rounded-md bg-accent py-2 text-xs text-center font-semibold"
                onClick={() =>
                  push(
                    PATH_PAGE.episode.view(
                      slug,
                      season.season_number,
                      episode.episode_number,
                    ),
                  )
                }
              >
                {t('play')}
              </button>
            </div>
          </div>
        </div>
        <div className="md:hidden my-3 flex flex-col items-end">
          <p className="text-sm mb-3 w-full">
            {locale === Language.EN
              ? episode.description_en
              : episode.description_es}
          </p>
          <button
            className="w-24 rounded-md bg-accent py-2 text-xs text-center font-semibold"
            onClick={() =>
              push(
                PATH_PAGE.episode.view(
                  slug,
                  season.season_number,
                  episode.episode_number,
                ),
              )
            }
          >
            {t('play')}
          </button>
        </div>
      </div>
    </>
  );
};

export default Episode;
